<script context="module" lang="ts">
	export enum TableColumn {
		none = "none",
		name = "name",
		username = "username",
		createddate = "createddate",
	}
	export type SortOrder = "none" | "asc" | "desc";

</script>

<script lang="ts">
	//UI
	import { SortByIcon } from "@hitit/new_ui";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	import moment from "moment";
	//Types
	import type { UserMinDto } from "@hitit/api";
	//Props
	export let columnHeadClickHandler: (
		columnName: TableColumn
	) => void = () => {};
	export let rowClickHandler = (userId: string) => {};
	export let sortOrder: SortOrder = "none";
	export let sortBy: TableColumn = TableColumn.none;
	export let users: UserMinDto[] = [];
	//Constants
	const headColumn = Object.keys(TableColumn).filter((v) => v !== "none");
	const columnConvert = (key: string) => {
		switch (key) {
			case "none":
				return TableColumn.none;
			case "name":
				return TableColumn.name;
			case "username":
				return TableColumn.username;
			case "createddate":
				return TableColumn.createddate;
			default:
				return TableColumn.none;
		}
	};
	//Variables
	//Functions
	function convertCreateDate(d: string) {
		return moment(d).format("yyyy-MM-DD HH:mm");
	}

	//Do

</script>

<div class="container">
	<div class="header">
		{#each headColumn as column}
			<div
				class={`col ${column}`}
				on:click={() => columnHeadClickHandler(columnConvert(column))}>
				{$t(`mbr.search.${column}`)}
				<span class="icon">
					<SortByIcon
						orderStatus={columnConvert(column) === sortBy ? sortOrder : 'none'} />
				</span>
			</div>
		{/each}
	</div>
	<div class="body">
		{#each users as user}
			<div class="row" on:click={() => rowClickHandler(user.id)}>
				<div class="col name">{user.name}</div>
				<div class="col username">{user.username}</div>
				<div class="col createddate">{convertCreateDate(user.createddate)}</div>
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		.header {
			display: none;
			color: #6d6f76;
			.col {
				&:hover {
					cursor: pointer;
				}
			}
		}
		.body {
			display: flex;
			flex-direction: column;
			color: #46474b;
			.row {
				display: flex;
				transition: background-color 0.5s;
				padding: 20px 0px;
				&:not(:last-child) {
					border-bottom: 1px solid #e6e7ec;
				}
				&:hover {
					cursor: pointer;
					background-color: #f0f0f4;
				}
				.col {
					display: none;
				}

				.name {
					display: flex !important;
					font-weight: 500;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			display: flex;
			width: 100%;
			gap: 10px;
			.header {
				display: flex;
				font-size: 1.25rem;
				.col {
					gap: 4px;
				}
				.icon {
					width: 16px;
					height: 17px;
				}
			}

			.body {
				display: flex;
				font-size: 1.25rem;

				.row {
					flex-direction: row;
					box-sizing: border-box;
					padding: 20px 0px;
				}

				.col {
					display: flex !important;
				}
			}

			.col {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				word-break: break-all;
			}

			.name {
				width: calc(100% * (1 / 3));
			}
			.username {
				width: calc(100% * (1 / 3));
			}
			.createddate {
				width: calc(100% * (1 / 3));
			}
		}
	}

</style>
